import NumeroProcessoUtil from './NumeroProcessoUtil';

/**
 * @classdesc Auxilia a manipulação de variáveis para interação com as ferramentas APM/APMO.
 */
class ApmVars {
    static ARMAZENAR_DADOS_SESSION_STORAGE = false;
    static #instance;

    static numeroProcesso;
    static sessaoId;
    static acaoUsuarioId;

    constructor() {
        throw new Error('Deve existir apenas uma instância.');
    }

    static getInstance() {
        if (!ApmVars.#instance) {
            ApmVars.#instance = this;
        }

        return ApmVars.#instance;
    }

    static getTagNumeroProcesso() {
        return this.ARMAZENAR_DADOS_SESSION_STORAGE ? sessionStorage.getItem('numeroProcesso') : this.numeroProcesso;
    }

    static setTagNumeroProcesso(numeroProcesso) {
        if (numeroProcesso || numeroProcesso === '') {
            const numeroProcessoFormatado = numeroProcesso
                ? NumeroProcessoUtil.formatarNumeroProcesso(numeroProcesso, false, true)
                : '';
            this.numeroProcesso = numeroProcessoFormatado;

            if (this.ARMAZENAR_DADOS_SESSION_STORAGE) {
                sessionStorage.setItem('numeroProcesso', numeroProcessoFormatado);
            }
        }
    }

    static getTagSessaoId() {
        return this.ARMAZENAR_DADOS_SESSION_STORAGE ? sessionStorage.getItem('sessaoId') : this.sessaoId;
    }

    static setTagSessaoId(sessaoId) {
        if (sessaoId || sessaoId === '') {
            this.sessaoId = sessaoId;

            if (this.ARMAZENAR_DADOS_SESSION_STORAGE) {
                sessionStorage.setItem('sessaoId', sessaoId);
            }
        }
    }

    static getTagAcaoUsuarioId() {
        return this.ARMAZENAR_DADOS_SESSION_STORAGE ? sessionStorage.getItem('acaoUsuarioId') : this.acaoUsuarioId;
    }

    static setTagAcaoUsuarioId(acaoUsuarioId) {
        if (acaoUsuarioId || acaoUsuarioId === '') {
            this.acaoUsuarioId = acaoUsuarioId;

            if (this.ARMAZENAR_DADOS_SESSION_STORAGE) {
                sessionStorage.setItem('acaoUsuarioId', acaoUsuarioId);
            }
        }
    }

    static getAllTags() {
        const numeroProcesso = this.getTagNumeroProcesso();
        const sessaoId = this.getTagSessaoId();
        const acaoUsuarioId = this.getTagAcaoUsuarioId();

        const tags = {};

        if (numeroProcesso) {
            tags.numeroProcesso = numeroProcesso;
        }

        if (sessaoId) {
            tags.sessaoId = sessaoId;
        }

        if (this.acaoUsuarioId) {
            tags.acaoUsuarioId = acaoUsuarioId;
        }

        return Object.keys(tags).length > 0 ? tags : null;
    }

    static resetTags() {
        this.setTagNumeroProcesso('');
        this.setTagSessaoId('');
        this.setTagAcaoUsuarioId('');
    }
}

export default ApmVars;
